import React from 'react'
import cx from 'classnames'
import { Link, l } from '@manychat/manyui'

import { useAppDispatch } from 'reduxTyped'
import { openIconBlockedModal } from 'common/core/actions/uiActions'
import { FusionAnalytics } from 'common/fusion/lib/fusionAnalytics'
import { useDidMountEffect } from 'utils/commonHooks'

import cm from '../StaticNotifications.module.css'

export const IconBlockedNotification = () => {
  const dispatch = useAppDispatch()

  useDidMountEffect(() => {
    FusionAnalytics.logBlockedNotificationShow()
  })

  const handleLearnMore = () => {
    dispatch(openIconBlockedModal('notification_bar'))
  }

  return (
    <>
      <span>
        {l.translate(
          '<l10n context="Icon is untranslatable"/>Check your Instagram settings to keep using Icon.',
        )}
      </span>
      <Link
        as="button"
        type="button"
        className={cx(cm.inverseLink, 'm-l-xxs')}
        onClick={handleLearnMore}
        data-test-id="icon-blocked-notification-learn-more"
      >
        {l.translate('Learn more')}
      </Link>
    </>
  )
}
